
import Group from 'vux/src/components/group/index.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'


export default {
name: "Askpay",
components: {Group, XInput, XButton},
data() {
return {
payInfo: {
amount: '',
company: '',
baccount: '',
bank: ''
},
header: {
headers: {
token: localStorage.getItem('token'),
opid: localStorage.getItem('userid')
}
},
seq: this.$route.params.seq,
role: this.$route.params.role,
type: this.$route.params.type
}
},
methods: {
confirmPay() {
if (!this.payInfo.amount || !this.payInfo.baccount || !this.payInfo.bank || !this.payInfo.company) {
alert('请填写信息');
return;
}
this.$http.post('/api/v1/normalrepairs/' + this.seq + '/ask_user_pay_repair', {role: this.role, ...this.payInfo}, this.header)
.then(() => {
alert('请求成功');
this.$router.push({name: 'RepairSrvp', query: {seq: this.seq, role: this.role, type: this.type}})
}).catch(err => {
this.$vux.toast.show({
text: JSON.parse(err.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
});
},
cancelPay() {
this.$router.push({name: 'RepairSrvp', query: {seq: this.seq, role: this.role, type: this.type}})
}
},
created() {
this.$http.get('/api/v1/payments/' + localStorage.getItem('userid') + '/orders/get_latest_repair_bank?role=' + this.role, this.header)
.then(response => {
if (response) {
this.payInfo.baccount = response.data['baccount'];
this.payInfo.bank = response.data['bank'];
this.payInfo.company = response.data['company'];
}
}).catch(err => {
this.$vux.toast.show({
text: JSON.parse(err.response.data.error_message).zh_string,
type: 'cancel',
time: '1000'
})
});
}
}



// WEBPACK FOOTER //
// ./src/components/Pay/Askpay.vue